import { Typography, Divider } from "@mui/material";

const Aboutus = () => {
  return (
    <div style={{ padding: "50px 80px" }}>
      <Typography variant="h4">About Us</Typography>
      <br />
      <Divider />
      <br />
      <Typography variant="subtitle1">
        ACC Copilot for WhatsApp is developed by CCTech. A community of
        passionate individuals whose purpose is to bring technology to common
        people. We envision a world where people have access to latest
        technology and use it for the betterment of their life. We are the bunch
        of technologists with diverse expertise in CAD Softwares. We love to
        create awesome products to simplify complex technologies for designers
        and engineers.
      </Typography>
    </div>
  );
};

export default Aboutus;
